<template>
  <div class="bigB">
    <div class="bigCenter">
      <div class="product">
        <div class="PRODUCT">PRODUCT</div>
        <div class="productLine">
          <span>{{ title.title.columname }}</span>
          <ul class="ul1">
            <li
              :class="{ active: index == curId }"
              v-for="(item, index) in columname"
              :key="index"
              @click="tab(index)"
            >
              {{ item.columname }}
            </li>
          </ul>
        </div>
        <div class="Index">
          <div
            class="IndexList"
            :class="{ active: index == ID }"
            v-for="(item, index) in Product"
            :key="index"
            @click="Btn(index)"
          ></div>
        </div>

        <div class="cross">
          <div class="NO">
            <div class="swiper" id="swiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide wow animated bounceInLeft"
                  v-for="item in Product"
                  :key="item.images"
                  @click="goDetail(item.id,8)"
                >
                  <img :src="item.images" alt="" />

                  <div class="P">
                    <p class="p1" :title="item.columname">
                      {{ item.columname }}
                    </p>
                    <p
                      class="p2"
                      :title="item.columname"
                      v-html="item.brief"
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>
<script>
import { WOW } from "wowjs";
import { getFooter, GetHomePage_Two } from "@/https/http";
import Swiper from "swiper";
import "../../../node_modules/swiper/css/swiper.min.css";
export default {
  data() {
    return {
      msg: "",
      num: 5,
      BannerList: "",
      column: "",
      columImg: "",
      Threecolum: "",
      curId: 0,
      columname: "",
      Product: "",
      arr: [],
      OneArr: [],
      title: { title: "" },
      ID: 0,
      swiper: "",
    };
  },
  methods: {
    Btn(x) {
      console.log(x);
      this.ID = x;
      this.swiper.slideTo(x, 500, false);
    },
    tab(index) {
      this.ID = 0;
      this.curId = index;
      GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
        (res) => {
          this.Product = res.result.data;
        }
      );
    },
    goDetail(id,modular){
      // id: item.id, modular: 8
      let routerData = this.$router.resolve({
        path:'/special',
        query: { id: id, modular: modular}

      })
      window.open(routerData.href,'_blank')

    }
  },
  created() {
    getFooter({ type: "1" }).then((res) => {
      res.result.data.forEach((item) => {
        if (item.modular === "8") {
          this.column = item;
          this.arr.push(item);
        }
      });
      GetHomePage_Two({ column_id: this.arr[0].id }).then((res) => {
        this.title = res.result;
        this.columname = res.result.data;
        GetHomePage_Two({ column_id: this.columname[this.curId].id }).then(
          (res) => {
            this.Product = res.result.data;
            // this.Product = res.result.data.concat(res.result.data);
          }
        );
      });
    });
  },
  mounted() {
    const that = this;
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
    // 这是轮播图组件
    this.$nextTick(function () {
      this.swiper = new Swiper("#swiper", {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          slideChangeTransitionStart: function () {
            console.log(this.activeIndex);
            that.ID = this.activeIndex;
          },
          slideNextTransitionStart: function () {
            console.log(123);
          },
        },
      });
    });
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1020px){
  .Index {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .IndexList {
    width: 22px;
    height: 22px;
    background: transparent;
    border-radius: 50%;
    top: 247px;
    margin-top: 22px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      width: 10px;
      height: 10px;
      background: #ff8229;
      content: "";
      border-radius: 50%;
      display: block;
    }
  }
  .IndexList.active {
    border: 1px solid #ff8229;
    margin-left: 0px;
    &::after {
      width: 10px;
      height: 10px;
      background: #ff8229;
    }
  }
}
.cross {
  width: 100%;
  height: 480px;
  padding-top: 95px;
  overflow: hidden;
  .NO {
    width: 1264px;
    height: 480px;
    position: absolute;
    /* margin-left: 173px; */
    .swiper {
      left: 173px;

      position: relative;
      width: 1264px;
      overflow: hidden;
    }
    .swiper-wrapper {
      /* width: 1264px;
      height: 480px; */
      .swiper-slide {
        width: 100% !important  ;
        /* margin-right: 4px; */
      }
      img {
        width: 625px;
        height: 427px;
      }
    }
    .P {
      float: right;
      width: 410px;
      height: 233px;
      margin-top: 108px;
      /* margin-right: 4px; */
      .p1 {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 30px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .p2 {
        width: 402px;
        height: 167px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }
}

a {
  text-decoration: none;
}
.bigB {
  width: 100%;
  height: 840px;
  min-width: 1427px;
  .bigCenter {
    height: 840px;
    width: 1427px;
    margin: 0 auto;
    .product {
      width: 100%;
      height: 105px;
      .PRODUCT {
        margin-bottom: 26px;
        width: 94px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #b3b3b3;
        line-height: 30px;
        margin-top: 62px;
      }
      .productLine {
        margin-top: 26px;
        > span {
          width: 235px;
          height: 60px;
          font-size: 60px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #4d4d4d;
          line-height: 30px;
        }
      }
      ul {
        float: right;
        list-style: none;
        display: flex;
        li.active {
          color: #ff8229;
        }
        li {
          width: 64px;
          height: 17px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 30px;
          margin-left: 62px;
          cursor: pointer;
        }

        li:hover {
          width: 64px;
          height: 17px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ff8229;
          line-height: 30px;
        }
      }
      .Swiper {
        width: 100%;
        height: 480px;
        margin-top: 95px;
        overflow: hidden;
        .swiper {
          width: 770px;
          /* float: right; */
          height: 480px;
          border-radius: 0px;
          position: absolute;
          margin-left: 157px;
          float: left;
          .swiper-wrapper {
          }
        }
      }
    }
  }
}
}


@media screen and (max-width:1020px) {
  .cross{
    width: 100%;
    // padding-left:20px;
    // padding-right:20px;
    // box-sizing: border-box;
    height: 550px;
    .NO{
      height: 550px;
      position: absolute;
      .swiper{
        margin-top:20px;
        width:95%;
        position: relative;
        overflow: hidden;
      }
      .swiper-wrapper{
        .swiper-slide{
          width: 100% !important;
        }
        img{
          width: 100%;
          height:200px;
          overflow: hidden;
          
        }
      }
      .P{
        width: 100%;
        .p1 {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1a1a1a;
          line-height: 30px;
          cursor: pointer;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      .p2 {
        height: 167px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        cursor: pointer;
      }
      }
    }
  }
   .bigB{
     width: 100%;

     .bigCenter{
       width: 100%;
       .product{
         padding-left:20px;
         padding-right:20px;
         box-sizing: border-box;
         width:100%;
         .PRODUCT {
            margin-bottom: 26px;
            // width: 94px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #b3b3b3;
            line-height: 30px;
            margin-top: 42px;
          }
          .productLine {
            margin-top: 26px;
            > span {
              width: 235px;
              height: 60px;
              font-size: 40px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #4d4d4d;
              line-height: 30px;
            }
          }
       }
       .ul1{
         display:none;
       }
     }
   }
}
</style>